import LineGradient from "../components/LineGradient";
import { motion } from "framer-motion";
import html from '../assets/html.png'
import css from '../assets/icons8-css3-64.png'
import bootstrap from '../assets/bootstrap.png'
import tailwind from '../assets/tailwind-css-icon.png'
import javascript from '../assets/java-script.png'
import react from '../assets/react-js-icon.png'
import nodejs from '../assets/node-js-icon.png'
import next from '../assets/nextjs.png'
import typescript from '../assets/icons8-typescript-50.png'
import mongoDb from '../assets/mongodb-icon.png'
import expressjs from '../assets/icons8-express-js-64.png'
import useMediaQuery from "../hooks/useMediaQuery";


const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const projectVariant = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1 },
};

// const myskills = ({ title }) => {
//   const overlayStyles = `absolute h-full w-full opacity-0 hover:opacity-90 transition duration-500
//     bg-grey z-30 flex flex-col justify-center items-center text-center p-16 text-deep-blue`;
//   const projectTitle = title.split(" ").join("-").toLowerCase();

//   return (
//     <motion.div variants={projectVariant} className="relative">
//       <div className={overlayStyles}>
//         <p className="text-2xl font-playfair">{title}</p>
//         <p className="mt-7">
//           {/* Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem. Nulla
//           porttitor accumsan tincidunt. */}
//         </p>
//       </div>
//       <img src={`../assets/${projectTitle}.jpeg`} alt={projectTitle} />
//     </motion.div>
//   );
// };

const MySkill = () => {
  const isAboveLarge = useMediaQuery("(min-width: 1060px)");
  return (
    <section id="myskills" className="pt-48 pb-48">
      {/* HEADINGS */}
      <motion.div
        className="md:w-2/5 mx-auto text-center"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.5 }}
        variants={{
          hidden: { opacity: 0, y: -50 },
          visible: { opacity: 1, y: 0 },
        }}
      >
        <div>
          <p className="font-playfair font-semibold text-4xl">
            <span className="text-cyan-500">MY</span> SKILLS
          </p>
          <div className="flex justify-center mt-5">
            <LineGradient width="w-2/3" />
          </div>
        </div>
        <p className="mt-10 mb-10">
          I acquired these skills till now
        </p>
      </motion.div>

      {/* SKILLS */}
      <div className="flex justify-center">
        <motion.div
          className="sm:grid sm:grid-cols-3"
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {/* ROW 1 */}
          <div
            className="flex justify-center text-center items-center border border-2 m-2 p-0
              max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold"
          >
            <div className="w-[50px]">
              <img className="w-full" src={html} alt="" />
            </div>
            HTML
          </div>
          <div
            className="flex justify-center text-center items-center p-10 border border-2 m-2
              max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold"
          >
            <div className="w-[50px]">
              <img className="w-full" src={css} alt="" /></div>
            CSS
          </div>
          <div
            className="flex justify-center text-center items-center p-10 border border-2 m-2
              max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold"
          ><div className="w-[50px]">
              <img className="w-full" src={bootstrap} alt="" /></div>
            BOTSTRAP
          </div>

          <div
            className="flex justify-center text-center items-center p-10 border border-2 m-2
              max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold"
          ><div className="w-[50px]">
              <img className="w-full" src={tailwind} alt="" /></div>
            TAILWIND
          </div>
          <div
            className="flex justify-center text-center items-center p-10 border border-2 m-2
              max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold"
          ><div className="w-[50px]">
              <img className="w-full" src={javascript} alt="" /></div>
            JAVASCRIPT
          </div>
          <div
            className="flex justify-center text-center items-center p-10 border border-2 m-2
              max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold"
          ><div className="w-[50px]">
              <img className="w-full" src={react} alt="" /></div>
            REACT
          </div>
         
          <div
            className="flex justify-center text-center items-center p-10 border border-2 m-2
              max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold"
          ><div className="w-[50px]">
              <img className="w-full" src={react} alt="" /></div>
            NEXT
          </div>
          <div
            className="flex justify-center text-center items-center p-10 border border-2 m-2
              max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold"
          ><div className="w-[50px]">
              <img className="w-full" src={react} alt="" /></div>
            REACT NATIVE
          </div>
          <div
            className="flex justify-center text-center items-center p-10 border border-2 m-2
              max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold"
          ><div className="w-[50px]">
              <img className="w-full" src={expressjs} alt="" /></div>
            EXPRESS JS
          </div>
          <div
            className="flex justify-center text-center items-center p-10 border border-2 m-2
              max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold"
          ><div className="w-[50px]">
              <img className="w-full" src={nodejs} alt="" /></div>
            NODE JS
          </div>
          <div
            className="flex justify-center text-center items-center p-10 border border-2 m-2
              max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold"
          ><div className="w-[30px]">
              <img className="w-full" src={mongoDb} alt="" /></div>
            MONGODB
          </div>
          <div
            className="flex justify-center text-center items-center p-10 border border-2 m-2
              max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold"
          ><div className="w-[40px]">
              <img className="w-full" src={next} alt="" /></div>
            Next Js
          </div>
          <div
            className="flex justify-center text-center items-center p-10 border border-2 m-2
              max-w-[400px] max-h-[400px] text-2xl font-playfair font-semibold"
          ><div className="w-[30px]">
              <img className="w-full" src={typescript} alt="" width={30} /></div>
            Typescript
          </div>


        </motion.div>
      </div>
    </section>
  );
};

export default MySkill;
